// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Ordering types enum.
 */
export enum OrderTypeEnum {
  None = 0,
  Ascending = 1,
  Descending = 2
}
